import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getOEM, postOEM } from "../Redux/OEM/actionCreater";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import TableRow from "./../Components/TableRow";
import AddModel from "../Components/AddModel";

const Deals = () => {
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [new_model, setNewModel] = useState({
    vehicle_oem_name: "",
    vehicle_model_name: "",
    year_of_launch: "",
    vehicle_ex_showroom_price: "",
    vehicle_available_colors: "",
    vehicle_mileage: "",
    vehicle_power: "",
    vehicle_max_speed: "",
    image: ""
  });
  // const isTableFullWidth = useBreakpointValue({ base: true, md: false });
  const { token } = useSelector((store) => store.auth);
  const { oem_specs } = useSelector((store) => store.oem);
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  //const [searchTerm, lastExecutedTime] = useDebounce(search, 200);
  useEffect(() => {
    dispatch(getOEM(token, page));
    console.log(oem_specs);
  }, [page]);

  const handlePageNext = (page) => {
    setPage((page) => page + 1);
  };

  const handlePagePrev = (page) => {
    setPage((page) => page - 1);
  };

  const handleSearch = async () => {
    try {
      dispatch(getOEM(token, page, search));
      console.log("Search term:", search);
    } catch (error) {
      console.error("Search error:", error);
    }
  };
  
  const handleAddModelClick = () => {
    setIsModalOpen(true);
  };

  const handleChangeModalInput = (e) => {
    let { name, value } = e.target;

    if (
      name === "vehicle_ex_showroom_price" ||
      name === "vehicle_mileage" ||
      name === "vehicle_power" ||
      name === "vehicle_max_speed" ||
      name === "odomoter_reading" ||
      name === " major_scrates" ||
      name === "vehicle_previous_accidents" ||
      name === "number_of_previous_buyers" ||
      name === "vehicle_dealer_price"
    ) {
      value = Number(value);
    }

    setNewModel((prevDetails) => ({
      ...prevDetails,
      [name]: value
    }));
  };

  const handleAddNewModelToDb = () => {
    console.log(new_model, token);
    dispatch(postOEM(token, new_model));
    toast.success({
      title: `New OEM Model Added successfully`,
      position: "top",
      isClosable: true,
      colorScheme: "whatsapp"
    });
    dispatch(getOEM(token, page));
  };

  return (
    <>
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-center mb-4 mt-10">
          <input
            name="search"
            placeholder="Search by Model, Manufacturer, or Year"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="p-3 border rounded w-2/5"
          />
          <button
            onClick={handleSearch}
            className="bg-blue-500 text-white py-3 px-6 rounded"
          >
            Search
          </button>
        </div>
        <button
          onClick={handleAddModelClick}
          className="text-orange-500 hover:bg-orange-200 hover:text-black cursor-pointer underline mb-4 "
        >
          Can't find your desired model? Click here to add a new OEM model and
          specifications.
        </button>
        <p className="text-orange-500 mb-4">
          * Click on "Select Model" to pick an existing model with OEM specs and
          customize it for your inventory.
        </p>
        <div className="overflow-x-auto flex justify-center items-center">
          <table className="min-w-full bg-white border-collapse border border-gray-300 shadow-lg rounded-lg">
            <caption className="text-lg text-center text-gray-600 mb-4 font-bold">
              OEM SPECIFICATIONS
            </caption>
            <thead className="bg-blue-500 text-white">
              <tr>
                <th className="py-3 px-6 text-center">Manufacturer</th>
                <th className="py-3 px-6 text-center">Model</th>
                <th className="py-3 px-6 text-center">Year of Launch</th>
                <th className="py-3 px-6 text-center">Ex-showroom Price</th>
                <th className="py-3 px-6 text-center">Colors</th>
                <th className="py-3 px-6 text-center">Mileage</th>
                <th className="py-3 px-6 text-center">Max Speed (km/h)</th>
                <th className="py-3 px-6 text-center">Power (BHP)</th>
                <th className="py-3 px-6 text-center">Image</th>
                <th className="py-3 px-6 text-center">Select</th>
              </tr>
            </thead>
            <tbody>
              {oem_specs?.map((el) => {
                return <TableRow el={el} key={el._id} />;
              })}
            </tbody>
          </table>
        </div>

        <div className="flex items-center justify-center mt-20">
          <button
            onClick={handlePagePrev}
            className="bg-blue-500 text-white py-1 px-3 rounded mr-5"
          >
            Previous
          </button>
          <span className="text-center">Page: {page}/9</span>
          <button
            onClick={handlePageNext}
            className="bg-blue-500 text-white py-1 px-3 rounded ml-5"
          >
            Next
          </button>
        </div>
      </div>
      <ToastContainer />

      {/* Render the ModelScreen component here */}
      <AddModel
        isModalOpen={isModalOpen}
        new_model={new_model}
        handleChangeModalInput={handleChangeModalInput}
        handleAddNewModelToDb={handleAddNewModelToDb}
        closeModal={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default Deals;
